class DeviceUsageDirective
  @$inject: ["$timeout"]
  constructor: ($timeout)->       
    class DeviceUsage      
      restrict: "A"
      bindToController: 
        device: "="        
      controllerAs: "$usage"
      controller: ($scope, $element, $attrs)->
        observers = []
        running = null
        @available = false
        watching = $scope.$watch "device", (val)=>
          if val and val.status is "A"
            @refresh()         
            watching()
        $scope.$on '$destroy', ()->
          $timeout.cancel running

        @register = (observer)->
          if observer not in observers
            observers.push observer

        @refresh = ()->
          if observers
            $scope.device.$usage().then (usage)=>
              @available = true
              observers.forEach (observer)=>                
                observer && observer(usage)

              running = $timeout @refresh.bind(@), 10000   
            .catch ()->
              $timeout.cancel running
              
        return @
    return new DeviceUsage()

  
module.exports = DeviceUsageDirective


// WEBPACK FOOTER //
// ./src/component/device/usage/usage.coffee